import React from 'react';
import ReactDOM from 'react-dom/client';
import CakesLandingPage from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CakesLandingPage />
  </React.StrictMode>
);